import React, { useState, useEffect } from 'react';
import { listarUsuarios, criarUsuario, atualizarUsuario, removerUsuario } from '../services/api';
import { iniciais, avColor, CAMPANHAS } from '../services/utils';

const PERFIS    = ['atendente', 'supervisor'];
const NUMEROS   = [{ id: 'campanhas', label: 'Campanhas' }, { id: 'comercial', label: 'Comercial' }];
const CAMPS_OPT = Object.entries(CAMPANHAS).map(([id, v]) => ({ id, label: v.label }));

export default function Atendentes() {
  const [usuarios,  setUsuarios]  = useState([]);
  const [modal,     setModal]     = useState(false);
  const [editando,  setEditando]  = useState(null);
  const [form,      setForm]      = useState(formVazio());
  const [salvando,  setSalvando]  = useState(false);
  const [erro,      setErro]      = useState('');

  useEffect(() => { carregar(); }, []);

  async function carregar() {
    try {
      const { data } = await listarUsuarios();
      setUsuarios(data.usuarios);
    } catch {}
  }

  function formVazio() {
    return { nome: '', email: '', senha: '', perfil: 'atendente', numero: 'campanhas', campanhas: [], ativo: 1 };
  }

  function abrirNovo() {
    setEditando(null);
    setForm(formVazio());
    setErro('');
    setModal(true);
  }

  function abrirEditar(u) {
    setEditando(u);
    setForm({
      nome:      u.nome,
      email:     u.email,
      senha:     '',
      perfil:    u.perfil,
      numero:    u.numero || 'campanhas',
      campanhas: u.campanhas || [],
      ativo:     u.ativo,
    });
    setErro('');
    setModal(true);
  }

  async function salvar() {
    if (!form.nome || !form.email) { setErro('Nome e email são obrigatórios.'); return; }
    if (!editando && !form.senha)  { setErro('Informe uma senha.'); return; }
    setSalvando(true);
    try {
      const payload = {
        nome:      form.nome,
        email:     form.email,
        perfil:    form.perfil,
        numero:    form.perfil === 'supervisor' ? null : form.numero,
        campanhas: form.perfil === 'supervisor' || form.numero === 'comercial' ? [] : form.campanhas,
        ativo:     form.ativo,
      };
      if (form.senha) payload.senha = form.senha;

      if (editando) await atualizarUsuario(editando.id, payload);
      else          await criarUsuario(payload);

      setModal(false);
      carregar();
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao salvar.');
    }
    setSalvando(false);
  }

  async function remover(u) {
    if (!window.confirm(`Remover ${u.nome}?`)) return;
    try {
      await removerUsuario(u.id);
      carregar();
    } catch {}
  }

  function toggleCamp(id) {
    setForm(f => ({
      ...f,
      campanhas: f.campanhas.includes(id)
        ? f.campanhas.filter(c => c !== id)
        : [...f.campanhas, id],
    }));
  }

  const ativos   = usuarios.filter(u => u.ativo && u.perfil !== 'admin');
  const inativos = usuarios.filter(u => !u.ativo);

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <div>
          <h2 style={styles.title}>Atendentes</h2>
          <p style={styles.sub}>{ativos.length} cadastrados</p>
        </div>
        <button className="btn btn-primary" onClick={abrirNovo}>
          <i className="ti ti-plus" /> Novo atendente
        </button>
      </div>

      {/* Cards de atendentes */}
      <div style={styles.grid}>
        {ativos.map((u, i) => {
          const av = avColor(i);
          return (
            <div key={u.id} style={styles.card} className="animate-fade">
              <div style={styles.cardTop}>
                <div className="avatar" style={{ width: 44, height: 44, fontSize: 14, background: av.bg, color: av.color }}>
                  {iniciais(u.nome)}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={styles.cardName}>{u.nome}</div>
                  <div style={styles.cardEmail}>{u.email}</div>
                </div>
                <div style={styles.cardActions}>
                  <button className="btn" style={{ padding: '5px 8px' }} onClick={() => abrirEditar(u)}>
                    <i className="ti ti-edit" style={{ fontSize: 15 }} />
                  </button>
                  <button className="btn btn-danger" style={{ padding: '5px 8px' }} onClick={() => remover(u)}>
                    <i className="ti ti-trash" style={{ fontSize: 15 }} />
                  </button>
                </div>
              </div>
              <div style={styles.cardTags}>
                <span className="pill" style={perfiBadge(u.perfil)}>{perfilLabel(u.perfil)}</span>
                {u.numero && (
                  <span className="pill" style={{ background: '#f0f2f5', color: '#54656f' }}>
                    {u.numero === 'campanhas' ? 'Campanhas' : 'Comercial'}
                  </span>
                )}
                {(u.campanhas || []).map(cid => {
                  const c = CAMPANHAS[cid];
                  return c ? (
                    <span key={cid} className="pill" style={{ background: c.bg, color: c.text }}>{c.label}</span>
                  ) : null;
                })}
              </div>
            </div>
          );
        })}
      </div>

      {/* Modal de cadastro/edição */}
      {modal && (
        <div style={styles.modalBg} onClick={() => setModal(false)}>
          <div style={styles.modal} onClick={e => e.stopPropagation()} className="animate-fade">
            <div style={styles.modalHead}>
              <span style={{ fontSize: 15, fontWeight: 600 }}>
                {editando ? 'Editar atendente' : 'Novo atendente'}
              </span>
              <button style={styles.modalClose} onClick={() => setModal(false)}>
                <i className="ti ti-x" />
              </button>
            </div>

            <div style={styles.modalBody}>
              <Field label="Nome completo">
                <input
                  style={styles.input}
                  value={form.nome}
                  onChange={e => setForm(f => ({ ...f, nome: e.target.value }))}
                  placeholder="Ex: João Silva"
                />
              </Field>

              <Field label="Email">
                <input
                  type="email"
                  style={styles.input}
                  value={form.email}
                  onChange={e => setForm(f => ({ ...f, email: e.target.value }))}
                  placeholder="joao@chatmj.com"
                />
              </Field>

              <Field label={editando ? 'Senha (deixe em branco para manter)' : 'Senha'}>
                <input
                  type="password"
                  style={styles.input}
                  value={form.senha}
                  onChange={e => setForm(f => ({ ...f, senha: e.target.value }))}
                  placeholder="••••••••"
                />
              </Field>

              <Field label="Perfil">
                <select
                  style={styles.input}
                  value={form.perfil}
                  onChange={e => setForm(f => ({ ...f, perfil: e.target.value }))}
                >
                  {PERFIS.map(p => <option key={p} value={p}>{perfilLabel(p)}</option>)}
                </select>
              </Field>

              {form.perfil === 'atendente' && (
                <>
                  <Field label="Número de acesso">
                    <select
                      style={styles.input}
                      value={form.numero}
                      onChange={e => setForm(f => ({ ...f, numero: e.target.value, campanhas: [] }))}
                    >
                      {NUMEROS.map(n => <option key={n.id} value={n.id}>{n.label}</option>)}
                    </select>
                  </Field>

                  {form.numero === 'campanhas' && (
                    <Field label="Campanhas designadas">
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 4 }}>
                        {CAMPS_OPT.filter(c => c.id !== 'com').map(c => {
                          const sel = form.campanhas.includes(c.id);
                          const info = CAMPANHAS[c.id];
                          return (
                            <button
                              key={c.id}
                              type="button"
                              onClick={() => toggleCamp(c.id)}
                              style={{
                                padding: '5px 12px',
                                borderRadius: 99,
                                border: `1.5px solid ${sel ? info.text : 'var(--border)'}`,
                                background: sel ? info.bg : 'transparent',
                                color: sel ? info.text : 'var(--text-secondary)',
                                fontSize: 12,
                                fontWeight: 500,
                                cursor: 'pointer',
                                transition: 'all 0.15s',
                              }}
                            >
                              {c.label}
                            </button>
                          );
                        })}
                      </div>
                    </Field>
                  )}
                </>
              )}

              {erro && <p style={{ fontSize: 12, color: '#dc2626', background: '#fef2f2', padding: '8px 12px', borderRadius: 8 }}>{erro}</p>}
            </div>

            <div style={styles.modalFoot}>
              <button className="btn" onClick={() => setModal(false)}>Cancelar</button>
              <button className="btn btn-primary" onClick={salvar} disabled={salvando}>
                {salvando ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function Field({ label, children }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
      <label style={{ fontSize: 11, fontWeight: 500, color: 'var(--text-secondary)' }}>{label}</label>
      {children}
    </div>
  );
}

function perfilLabel(p) {
  return p === 'admin' ? 'Admin' : p === 'supervisor' ? 'Supervisor' : 'Atendente';
}
function perfiBadge(p) {
  if (p === 'admin')      return { background: '#ede9fe', color: '#5b21b6' };
  if (p === 'supervisor') return { background: '#ecfdf5', color: '#065f46' };
  return { background: '#f0f2f5', color: '#54656f' };
}

const styles = {
  page:  { flex: 1, overflowY: 'auto', padding: 24, background: 'var(--bg-app)' },
  header:{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 },
  title: { fontSize: 18, fontWeight: 700, color: 'var(--text-primary)' },
  sub:   { fontSize: 12, color: 'var(--text-muted)', marginTop: 2 },
  grid:  { display: 'flex', flexDirection: 'column', gap: 10 },
  card:  {
    background: '#fff',
    borderRadius: 14,
    padding: '14px 16px',
    border: '1px solid var(--border)',
    boxShadow: 'var(--shadow-sm)',
  },
  cardTop: { display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 },
  cardName:  { fontSize: 13, fontWeight: 600, color: 'var(--text-primary)' },
  cardEmail: { fontSize: 11, color: 'var(--text-muted)', marginTop: 1 },
  cardActions: { display: 'flex', gap: 5, marginLeft: 'auto' },
  cardTags:  { display: 'flex', flexWrap: 'wrap', gap: 5 },
  modalBg: {
    position: 'fixed', inset: 0,
    background: 'rgba(0,0,0,0.35)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 100,
    padding: 16,
  },
  modal: {
    background: '#fff',
    borderRadius: 16,
    width: '100%',
    maxWidth: 440,
    maxHeight: '90vh',
    overflowY: 'auto',
    boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
  },
  modalHead: {
    padding: '16px 20px',
    borderBottom: '1px solid var(--border)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'sticky', top: 0,
    background: '#fff',
    zIndex: 1,
  },
  modalBody: { padding: '20px', display: 'flex', flexDirection: 'column', gap: 14 },
  modalFoot: {
    padding: '14px 20px',
    borderTop: '1px solid var(--border)',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 8,
    position: 'sticky', bottom: 0,
    background: '#fff',
  },
  modalClose: { border: 'none', background: 'none', fontSize: 18, color: 'var(--text-muted)', cursor: 'pointer' },
  input: {
    padding: '9px 12px',
    borderRadius: 9,
    border: '1.5px solid var(--border)',
    background: 'var(--bg-input)',
    fontSize: 13,
    color: 'var(--text-primary)',
    width: '100%',
    transition: 'border-color 0.15s',
  },
};
